/* eslint-disable-next-line */
export interface WebProductInfoItemProps {}

export function WebProductInfoItem(props: WebProductInfoItemProps) {
  return (
    <div>
      <h1>Welcome to WebProductInfoItem!</h1>
    </div>
  );
}

export default WebProductInfoItem;
